import { Box } from "@mantine/core";

/**
 * A sortable header renders its label inside a flex Group alongside the sort
 * icon, and a flex child ignores the cell's `text-align`. Growing the label to
 * fill the row is what actually pushes it to the column's right edge. Pair
 * with `endAlignedCellStyle` on the header and body cells.
 */
const EndAlignedHeader = ({ label }: { label: string }) => (
  <Box style={{ flex: 1, textAlign: "right" }}>{label}</Box>
);

export default EndAlignedHeader;
